<template>
  <div class="video-overlay"> 
    <div
      v-for="cell in 9"
      :key="cell"
      class="overlay-cell"
    >
            <!-- v-if="itemsByPosition[cell]?.length" -->
      <div
        class="cell-stack"
        >

        <!-- itemsByPosition[cell][0]?.transition -->
        <transition-group :name="transitionForCell(cell)" tag="div"> 
            <template  v-for="(item,index) in itemsByPosition[cell]" :key="index"  >
                <div v-if="item.type=='segment'">
                  <button v-for="segmentRef in item.items" class="btn btn-lg btn-danger hud-item" 
                  @click="onSegmentClick(item)" >{{ item.text?.length>0 ? item.text : segmentName(segmentRef.id)}}</button>
                </div>
                
                <div class="annotation"
                  :class="getAnnotationClass(item)"
                  v-else-if="item.type=='annotation' && item.text && /both|video/.test(item.location)" >{{ item.text }}</div>

                <button v-else-if="item.type=='navbutton'" :class="btnClass(item.className)"
                  @click="onNavButtonClick(item)" >{{ item.text }}</button>

                <!-- <code>{{ JSON.stringify(item) }}</code> -->
            </template> 
        </transition-group>

      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { btnClass } from '@/components/core/ButtonStyle';

const emit = defineEmits(["segmentClick", "navButtonClick"])

const props = withDefaults(
  defineProps<{
    segmentMap: Map<string,any>;
    items: any[];
    aspectRatio?: number;
  }>(),
  {
    items: () => [], // Set your default here
    aspectRatio: 16 / 9,
  }
);

function getAnnotationClass(item: any)
{
  if (item?.style?.class?.length>0) {
    return item.style.class.join(" ");
  }

  return "";
}

function segmentName(id: string)
{
  return props.segmentMap.get(id)?.name ?? "Exercise";
}
 
const onSegmentClick = (item: any)=>{
  emit("segmentClick", item);
}

const onNavButtonClick = (item: any)=>{
  emit("navButtonClick", item);
}

function transitionForCell(cell: number): string {
  return itemsByPosition.value[cell]?.[0]?.transition ?? 'fade';
}
const itemsByPosition = computed(() => {
  const map: any = {}
  for (const item of props.items) {
    const pos = Number((item as any).position)  // force number
    if (!map[pos]) map[pos] = []
    map[pos].push(item)
  }
  return map
});


</script>

<style lang="scss" scoped>
@import '@/theme/_helpers.scss';

  @property --offset {
  syntax: '<number>';
  inherits: false;
  initial-value: 0;
}
.video-overlay {
  /* Matches the letterboxed/pillarboxed video content box produced by the
     player's object-fit: contain, so grid cells align with actual video
     pixels rather than the full (possibly bar-padded) player container. */
  position: absolute;
  inset: 0;
  margin: auto;
  aspect-ratio: v-bind('props.aspectRatio');
  max-width: 100%;
  max-height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  pointer-events: none;
  overflow: visible;
}

.overlay-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
}

.cell-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  overflow: visible;
  pointer-events: none;

  .btn {
    pointer-events: auto;
  }
}



/* Default item style — override via slot content */
.annotation {
  font-size:2rem;
  padding:2rem;


  &.overlay-text-lg 
  {
    font-size:4rem;
  } 

  &.overlay-text-border 
  {
    border-color: $white 4pt;
  }

 &.overlay-emoji-xl {
    // scale to the smaller of the cell's width/height so it never
    // overflows into neighboring cells regardless of aspect ratio
    font-size: min(35cqw, 35cqh);
    line-height: 1;
    padding: 0; // the 2rem padding will fight the container-relative sizing
  }

  &.marching-ants {
  /* Create the physical space for the border */
  border: 4pt solid transparent; 
  
  /* Use the --offset variable inside a repeating linear gradient */
  border-image: repeating-linear-gradient(
    -45deg,
    #fff calc(var(--offset) * 1pt),
    #fff calc((var(--offset) + 10) * 1pt),
    transparent calc((var(--offset) + 10) * 1pt),
    transparent calc((var(--offset) + 20) * 1pt)
  ) 4; /* The '4' matches your border width */

  /* Run the animation */
  animation: march 1s linear infinite;
}

&.animation-shake {
   animation: shake 3s linear infinite;
}
 
/* 2. Animate the numeric variable smoothly from 0 to the dash cycle size (20) */


}


@keyframes march {
  from {
    --offset: 0;
  }
  to {
    --offset: 20;
  }
}
</style>